import React from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { Image, Text, View } from 'src/components/common';
import { IMAGES } from 'src/appConfig/images';
import './styles.scss';

const Home: React.FC<Props> = () => {
  return (
    <View flexGrow={1} justify="center" align="center">
      <Image src={IMAGES.background} className="ctn-home__background" />
      <Text className="has-text-centered">Welcome to Ralph Rosenberg Admin Dashboard</Text>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
